<app-pills-overflow [items]="pillItems()" [maxRows]="3" [pillHeight]="24" [gapSize]="6">
  <ng-template #pillTemplate let-item>
    <div
      class="bg-elevated border-default inline-flex w-full items-center overflow-hidden rounded-full border px-2.5 py-0.5 transition-all">
      <p class="text-text-primary text-2xs truncate font-mono font-medium">
        {{ item.data }}
      </p>
    </div>
  </ng-template>
</app-pills-overflow>
